import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { EnvironmentConfig } from "../../config/environmentConfig";

export default function Carousel({ classCode, images = [] }) {
  const [index, setIndex] = useState(0);
  const slides = images.map(
    (m) =>
      `${EnvironmentConfig.etim.imageBaseUrl}/${classCode}/${m.toLowerCase()}`,
  );
  const next = () => {
    setIndex((prev) => (prev + 1) % slides.length);
  };

  const prev = () => {
    setIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <Box
      sx={{
        position: "relative",
        height: 200,
        //border: "1px solid #ddd",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        "& .nav-btn": {
          opacity: 0,
          transition: "opacity 0.3s ease",
        },

        "&:hover .nav-btn": {
          opacity: 1,
        },
      }}
    >
      <Box
        component="img"
        src={slides[index]}
        //alt={`Slide ${index + 1}`}
        sx={{
          maxHeight: "100%",
          maxWidth: "100%",
          objectFit: "contain",
          display: "block",
        }}
      />

      <IconButton
        className="nav-btn"
        onClick={prev}
        sx={{
          position: "absolute",
          left: 8,
          top: "50%",
          transform: "translateY(-50%)",
          bgcolor: "rgba(255,255,255,0.8)",
          "&:hover": {
            bgcolor: "white",
          },
        }}
      >
        <ChevronLeftIcon />
      </IconButton>

      <IconButton
        className="nav-btn"
        onClick={next}
        sx={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          bgcolor: "rgba(255,255,255,0.8)",
          "&:hover": {
            bgcolor: "white",
          },
        }}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
}
